import pwgo_footer_logo from '../assets/images/pw_footer_logo.png'
import home_header_bg from '../assets/images/home_header_bg.png'
import pw_app_logo from '../assets/images/pw_app_logo.png'

export default {
	pwgo_footer_logo,
	home_header_bg,
	pw_app_logo,
}